import { render, staticRenderFns } from "./Webinars.vue?vue&type=template&id=58565856&scoped=true&"
import script from "./Webinars.vue?vue&type=script&lang=js&"
export * from "./Webinars.vue?vue&type=script&lang=js&"
import style0 from "./Webinars.vue?vue&type=style&index=0&id=58565856&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58565856",
  null
  
)

export default component.exports